import React from 'react';
import { ListDetailPage } from '@/components/lists/ListDetailPage';
import { usePageTitle } from '@/hooks/usePageTitle';

const ListDetail: React.FC = () => {
  return <ListDetailPage />;
};

export default ListDetail;
